const OPEN_CLASS = 'widget-navigation--open';

class WidgetNavigation {
  openOnStarMinWidth = 1620
  constructor($main) {
    this.$main = $main;
    this.content = $main.find('.widget-navigation__content');
    this.toggle = $main.find('.widget-navigation__toggle');
    this.toggle.on('click', event => {
      if (this.$main.hasClass(OPEN_CLASS)) {
        this.close();
      } else {
        this.open();
      }
    });

    if (this.getBrowserWidth() >= this.openOnStarMinWidth) {
      this.open(true);
    }
  }

  open(keepOpenOnLostFocus = false) {
    this.$main.addClass(OPEN_CLASS);

    this.content.slideDown(200);

    $(document).on('keydown.widget-navigation', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });

    if (!keepOpenOnLostFocus) {
      $(document).on('focusin.widget-navigation', (event) => {
        if (!this.$main[0].contains(event.target)) {
          this.close();
        }
      });

      $(document).on('click.widget-navigation', (event) => {
        if (!this.$main[0].contains(event.target)) {
          this.close();
        }
      });
    }
  }

  close() {
    this.content.slideUp(200);
    this.toggle.focus();
    this.$main.removeClass(OPEN_CLASS);
    $(document).off('focusin.widget-navigation');
    $(document).off('keydown.widget-navigation');
    $(document).off('click.widget-navigation');
  }

  getBrowserWidth() {
    return window.innerWidth || document.documentElement.clientWidth;
  }

}

export default WidgetNavigation;
